export const VIP_GOLD = 'VIP Gold';
export const VIP_BRONZE = 'VIP Bronze';
export const VIP_SILVER = 'VIP Silver';
